import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import { StyledStatistics, StatCard, StatValue, StatLabel } from "./Statistics.styles";
import { SectionContentWrapper } from "../../styled";

export const Statistics: React.FC = () => {
  const { t } = useTranslation();

  const stats = [
    { value: "15k+", label: t("home.statistics.specialists") },
    { value: "500k+", label: t("home.statistics.bookings") },
    { value: "45", label: t("home.statistics.cities") },
    { value: "4.9/5", label: t("home.statistics.rating") },
  ];

  return (
    <StyledStatistics>
      <SectionContentWrapper>
        <Row gutter={[32, 32]}>
          {stats.map((stat, index) => (
            <Col key={index} xs={12} md={6}>
              <StatCard>
                <StatValue>{stat.value}</StatValue>
                <StatLabel>{stat.label}</StatLabel>
              </StatCard>
            </Col>
          ))}
        </Row>
      </SectionContentWrapper>
    </StyledStatistics>
  );
};
